import styled from 'styled-components';

export const ModalContainer = styled.div`
  padding-bottom: 10px;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .searchBtn {
    margin-left: 10px;
  }
  .box-date {
    background-color: #fafafa;
    border: solid 2px #d9d9d9;
    padding: 1rem 0.5rem;
  }
`;
export const TitleLabel = styled.div`
  padding-bottom: 10px;
  font-size: 13px;
`;
